import LegalLinks from "./LegalLinks";

function Footer({ dark = false }) {
  const currentYear = new Date().getFullYear();
  const footerClassName = dark
    ? "w-full bg-[#14170f] py-4 px-5 mt-auto relative z-10"
    : "w-full bg-white shadow-[0_-8px_20px_-12px_rgba(0,0,0,0.1)] py-8 px-6 mt-auto relative z-10";
  const creditClassName = dark ? "text-white/58 text-xs" : "text-gray-600 text-sm";
  const linkClassName = dark
    ? "text-white/70 hover:text-white transition-all focus-visible:outline-2 focus-visible:outline-[#f4d94e]"
    : "hover:text-green-700 transition-all focus-visible:outline-2 focus-visible:outline-green-600";
  const analyticsClassName = dark
    ? "text-white/70 hover:text-white"
    : "";
  const legalClassName = dark
    ? "text-white/58"
    : "text-gray-500";
  const dividerClassName = dark ? "bg-white/12" : "bg-gray-200";
  const copyrightClassName = dark
    ? "text-xs text-white/42 font-normal"
    : "text-xs text-gray-400 font-normal";

  return (
    <footer
      className={footerClassName}
      aria-label="Site Footer"
    >
      <div className={`max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center ${dark ? "gap-3 sm:gap-5" : "gap-6"}`}>

        {/* Brand Credit */}
        <div className={creditClassName}>
          <span className="opacity-90">Made with care by</span>{" "}
          <a
            href="https://imoonshots.com"
            target="_blank"
            rel="noreferrer"
            className={dark
              ? "font-medium text-[#f4d94e] hover:text-[#fff6b8] transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#f4d94e] rounded-sm"
              : "font-bold text-green-700 hover:text-green-800 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-600 rounded-sm"}
          >
            Impact Moonshots
          </a>
        </div>

        {/* Links & Copyright */}
        <div className={`flex flex-col sm:flex-row items-center gap-3 sm:gap-6 ${dark ? "text-xs" : "text-sm"} ${legalClassName}`}>
          <LegalLinks
            className={dark ? "text-xs font-normal" : "font-medium"}
            linkClassName={linkClassName}
            analyticsClassName={analyticsClassName}
          />

          {/* Subtle Vertical Divider (Desktop Only) */}
          <div className={`hidden sm:block h-5 w-px ${dividerClassName}`} aria-hidden="true" />

          <span className={copyrightClassName}>
            &copy; {currentYear} Impact Moonshots
          </span>
        </div>

      </div>
    </footer>
  );
}

export default Footer;
